import { Button } from "@mui/material";
import { gsap } from "gsap";
import React, { useEffect, useRef, useState } from "react";
import { HiOutlineSwitchVertical } from "react-icons/hi";
import useUserDetails from "../hooks/useUserDetails";
import { clientsMasterList } from "../utils/constants";
import ChatWidgetBody from "./ChatWidgetBody";
import useGlobalState from "global-state-hooks/useGlobalState";
import { useTheme } from "hooks/useTheme";

function Main() {
  const { clinic } = useUserDetails();
  const { clinicIdList, selectClinic, clinicId } = useGlobalState();
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const closeChatWindow = () => {
    setOpen(false);
    const tl = gsap.timeline({});
    const chatWindow = document.getElementById("main-chat-window");
    const chatButton = document.getElementById("chat-button");
    tl.to(chatWindow, {
      translateY: 0,
      display: "none",
      opacity: 0,
      duration: 0.25,
    });
    tl.to(chatButton, { display: "block", opacity: 1, duration: 0.25 });
  };

  const openChatWindow = () => {
    const tl = gsap.timeline({});
    const chatWindow = document.getElementById("main-chat-window");
    const chatButton = document.getElementById("chat-button");
    setOpen(true);
    tl.to(chatWindow, {
      translateY: -10,
      display: "block",
      opacity: 1,
      duration: 0.5,
    });
    tl.to(chatButton, { display: "none", opacity: 0, duration: 0.5 }, -0.5);
  };
  useEffect(() => {
    const localStorageSetListener = (event) => {
      if (event?.detail?.triggerChat === true) {
        switch (open) {
          case true:
            console.log("true");
            closeChatWindow();
            break;
          case false:
            console.log("false");
            openChatWindow();
            break;
          default:
            console.log("default");
        }
      }
    };
    window.addEventListener("urlchange", localStorageSetListener);
    return () => {
      window.removeEventListener("urlchange", localStorageSetListener);
    };
  }, [open]);

  const handleSelectClinic = (id) => {
    selectClinic(id);
  };

  const clinicName = clientsMasterList?.find((item) => {
    return item.id === clinicId;
  })?.name;
  const theme = useTheme(clinicId);
  return (
    <div
      className="App"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxHeight: "90vh",
      }}
    >
      <div
        id={"main-chat-window"}
        style={{ translateY: "0", display: "none", opacity: "0" }}
        className="main-chatbox"
        ref={ref}
      >
        <div
          className="widget-chat-window-top"
          style={{
            display: "flex",
            justifyContent: "space-between",
            position: "relative",
            backgroundColor: theme.primary,
          }}
          onClick={() => {
            closeChatWindow();
          }}
        >
          <span>
            {
              clientsMasterList?.find((item) => {
                return item.id === clinicId;
              })?.name
            }{" "}
            Live Chat
          </span>
          {clinicIdList?.length > 1 && (
            <HiOutlineSwitchVertical
              onClick={(e) => {
                e.stopPropagation();
                selectClinic(null);
              }}
            />
          )}
        </div>
        <div style={{ backgroundColor: theme.main }}>
          {clinic?.id ? (
            <ChatWidgetBody clinicId={clinic.id} />
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                height: "520px",
              }}
            >
              <div className={"message incoming-message "}>
                <div className="i-img">DF</div>

                <div className={"i-message"}>
                  Please select the office you want to reach out to
                  <br />
                  {clientsMasterList?.map(
                    (item) =>
                      clinicIdList.includes(item.id) && (
                        <button
                          className="multi-clinic-button"
                          onClick={() => handleSelectClinic(item.id)}
                          key={item.id}
                        >
                          <span>{item.name}</span>
                        </button>
                      )
                  )}
                </div>
              </div>

              <br />
              <br />
              <br />
            </div>
          )}
        </div>
      </div>

      <Button
        className="open-chat-button"
        id="chat-button"
        style={{
          opacity: "1",
          backgroundColor: theme.primary,
        }}
        onClick={() => {
          openChatWindow();
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="white"
        >
          <path
            fillRule="evenodd"
            d="M12 2.25c-2.429 0-4.817.178-7.152.521C2.87 3.061 1.5 4.795 1.5 6.741v6.018c0 1.946 1.37 3.68 3.348 3.97.877.129 1.761.234 2.652.316V21a.75.75 0 001.28.53l4.184-4.183a.39.39 0 01.266-.112c2.006-.05 3.982-.22 5.922-.506 1.978-.29 3.348-2.023 3.348-3.97V6.741c0-1.947-1.37-3.68-3.348-3.97A49.145 49.145 0 0012 2.25zM8.25 8.625a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25zm2.625 1.125a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0zm4.875-1.125a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25z"
            clipRule="evenodd"
          />
        </svg>
      </Button>
    </div>
  );
}

export default Main;
